import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';

export const getFlatStringFilterValue = (
  filterValue: string | string[] | null,
): string => {
  if (Array.isArray(filterValue)) {
    stumble('Got array simple filter value where flat string was expected');
    return '';
  }
  return filterValue ?? '';
};
